import React from 'react';
import styled from 'styled-components';
import { grey, noticeWarning, rotateButtonBackgroundColor, separatorColor, white } from 'styles/Colors';
import { ReactComponent as DiscrepanciesIcon } from 'images/discrepanciesIcon.svg';

export const TopBarWrapper = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
`;

export const DiscrepanciesWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RefreshWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RefreshInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 11px;
  color: ${grey};
`;

export const DiscrepanciesChip = styled.div`
  font-size: 11px;
  line-height: 10px;
  background-color: ${noticeWarning};
  border-radius: 32px;
  width: fit-content;
  color: ${white};
  font-weight: 700;
  padding: 5px 8px;
  display: flex;
  align-items: center;
`;

export const DiscrepanciesText = styled.div`
  font-weight: 700;
  font-size: 15px;
`;

export const Separator = styled.div`
  border-right: 1px solid ${separatorColor};
  margin: 0 8px;
  height: 20px;
`;

export const StyledDiscrepanciesIcon = styled((props) => <DiscrepanciesIcon {...props} />)`
  margin-right: 4px;
`;

export const RefreshButton = styled.button`
  border: none;
  border-radius: 4px;
  background-color: ${rotateButtonBackgroundColor};
`;
